import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { IconButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Modal, ModalTypes } from '@eika/modal';
const UsTaxRelationsHelpModalCorporate = _ref => {
  let {
    className
  } = _ref;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const showModal = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    className: className,
    onClick: showModal,
    icon: IconTypes.INFO_20,
    id: "help-icon-overall-tax-relations",
    screenReaderText: "Hjelpetekst"
  }), /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    show: isModalOpen,
    id: "helpermodal__modal",
    type: ModalTypes.STANDARD,
    appNamespace: "kyc-declaration.app"
  }, /*#__PURE__*/React.createElement("div", {
    role: "tooltip",
    id: "helpermodal"
  }, /*#__PURE__*/React.createElement("p", null, "\u201CAmerikansk Identifikasjonsnummer\u201C betyr et amerikansk f\xF8deralt skatteyternummer (tax identification number, TIN). TIN best\xE5r av tall og skal v\xE6re p\xE5 formatet XXX-XX-XXX"), /*#__PURE__*/React.createElement(StandardButton, {
    className: "help-modal-button",
    onClick: closeModal
  }, "Lukk"))));
};
export default UsTaxRelationsHelpModalCorporate;